export default "__VITE_ASSET__DGhEvFSc__"